module.exports = __webpack_public_path__ + "media/07 Philippe Nonie - LDB.5dc44fec.mp3";